/**
 * Allowlist of email addresses that bypass the "Coming Soon" gating for the
 * filing options that aren't fully launched yet (Self Assessment Non-MTD,
 * Self Assessment MTD, Confirmation Statement). Beta users see those options
 * as fully active; everyone else sees them greyed out with a "Coming Soon"
 * badge.
 *
 * To grant access:
 *   - Add an email to STATIC_BETA_EMAILS below, OR
 *   - Set the VITE_FILING_BETA_EMAILS env var to a comma-separated list, e.g.
 *     VITE_FILING_BETA_EMAILS="alice@britfiler.com,bob@britfiler.com"
 *
 * Both sources are merged and compared case-insensitively.
 */

const STATIC_BETA_EMAILS: string[] = [
  // Add team / beta tester emails here.
  // 'atemy782@gmail.com',
  'akintokuntemmy@gmail.com',
  'ayankoyadare@gmail.com',
  'dareayankoya@gmail.com',
  'anetprofessionalslimited1729@gmail.com',
  'femijoshuaalabi3@gmail.com',
  'olatundesuccess54@gmail.com',
  'femijoshuaalabi@gmail.com',
  'britfilerltd@gmail.com',
]

const envList =
  (import.meta.env.VITE_FILING_BETA_EMAILS as string | undefined) || ''
const ENV_BETA_EMAILS = envList
  .split(',')
  .map(e => e.trim().toLowerCase())
  .filter(Boolean)

const ALLOWLIST = new Set<string>([
  ...STATIC_BETA_EMAILS.map(e => e.toLowerCase()),
  ...ENV_BETA_EMAILS,
])

export function isFilingBetaUser(email?: string | null): boolean {
  if (!email) return false
  return ALLOWLIST.has(email.trim().toLowerCase())
}
